import Created from './Created';
import CreatorUser from './CreatorUser';
import Id from './Id';
import Receipts from './Receipts';
import SourceStorage from './SourceStorage';
import TargetStorage from './TargetStorage';
import Type from './Type';
import Updated from './Updated';

export const labels = {
  Id: 'Id',
  SourceStorage: 'Forrás raktár',
  TargetStorage: 'Cél raktár',
  Receipts: 'Bizonylatok',
  Type: 'Típus',
  CreatorUser: 'Létrehozta',
  Created: 'Létrehozva',
  Updated: 'Módosítva',
};

export const allColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'SourceStorage',
}, {
  value: 'TargetStorage',
}, {
  value: 'Type',
}, {
  value: 'Receipts',
}, {
  value: 'CreatorUser',
}, {
  value: 'Updated',
}, {
  value: 'Created',
}];

export const defaultColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'SourceStorage',
}, {
  value: 'TargetStorage',
}, {
  value: 'Type',
}, {
  value: 'Receipts',
}, {
  value: 'CreatorUser',
}, {
  value: 'Created',
}];

export const defaultSort = {
  prop: 'id',
  order: 'descending'
};

export default {
  Id,
  SourceStorage,
  TargetStorage,
  Type,
  Receipts,
  CreatorUser,
  Created,
  Updated,
};
